import { useState } from "react";
import { SignalValidationChart } from "./SignalValidationChart";
import { SIGNALS } from "./signalValidationUtils";
import { SignalValidationDropdown } from "./SignalValidationDropdown";
import { Portal } from "@mui/material";

export function SignalValidationDropdownAndChart({
  ge,
  lt,
  machemetryId,
}: {
  ge: number;
  lt: number;
  machemetryId: string | null;
}) {
  const [isViewingEntireShift, setIsViewingEntireShift] = useState<
    "segment" | "shift" | "all"
  >("segment");

  const [{ activeUrl, activeSignal }, setActiveUrl] = useState<{
    activeUrl: string;
    activeSignal: keyof typeof SIGNALS | "";
  }>({ activeUrl: "", activeSignal: "" });

  return (
    <>
      <SignalValidationDropdown
        {...{
          ge,
          lt,
          machemetryId,
          activeUrl,
          setActiveUrl,
          isViewingEntireShift,
          setIsViewingEntireShift,
        }}
      />

      {activeUrl && machemetryId && (
        <Portal>
          <SignalValidationChart
            {...{
              activeSignal,
              activeUrl,
              machemetryId,
              isViewingEntireShift,
              handleClose: () => {
                setActiveUrl({
                  activeUrl: "",
                  activeSignal: "",
                });
              },
            }}
          />
        </Portal>
      )}
    </>
  );
}
